import React, { useState } from "react";

const API = process.env.REACT_APP_API_URL;

export default function OrganizationCreateModal({ open, onClose, onCreated }) {
  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  if (!open) return null;

  function close() {
    if (submitting) return;
    setName("");
    setCity("");
    setError("");
    onClose();
  }

  async function submit(event) {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const response = await fetch(`${API}/admin/organizations`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: name.trim(), residency_city: city.trim() || null }),
      });
      const organization = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(organization.error || "Organization could not be created.");
      setName("");
      setCity("");
      onCreated(organization);
      onClose();
    } catch (err) {
      setError(err.message || "Organization could not be created.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm">
      <form onSubmit={submit} role="dialog" aria-modal="true" aria-labelledby="create-organization-title" className="w-full max-w-lg rounded-2xl border border-black/10 bg-white p-6 shadow-2xl">
        <h2 id="create-organization-title" className="text-2xl font-semibold text-gray-900">Create organization</h2>
        <p className="mt-1 text-sm text-gray-600">Add an organization before creating its patients and devices.</p>

        <label className="mt-5 block text-sm font-medium text-gray-700">
          Organization name
          <input autoFocus required maxLength={120} value={name} onChange={(event) => setName(event.target.value)} className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 outline-none focus:border-[#76B3FF]" />
        </label>
        <label className="mt-4 block text-sm font-medium text-gray-700">
          Residency city <span className="font-normal text-gray-500">(optional)</span>
          <input maxLength={120} value={city} onChange={(event) => setCity(event.target.value)} className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 outline-none focus:border-[#76B3FF]" />
        </label>

        {error && <div className="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">{error}</div>}
        <div className="mt-6 flex justify-end gap-3">
          <button type="button" onClick={close} disabled={submitting} className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50">Cancel</button>
          <button type="submit" disabled={submitting || !name.trim()} className="rounded-lg bg-[#76B3FF] px-4 py-2 text-sm font-medium text-white hover:bg-blue-500 disabled:opacity-50">{submitting ? "Creating…" : "Create organization"}</button>
        </div>
      </form>
    </div>
  );
}
